<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.program_orders") }}</v-toolbar-title>
    </v-toolbar>
    <global-search-filter :queries="queries" ref="search_filter_ref" />
    <v-row>
      <v-col cols="12" sm="4" class="my-0 py-0">
        <v-select
          :items="items"
          item-text="text"
          item-value="id"
          v-model="status_id"
          :label="$t('labels.status')"
          outlined
          @change="handleFitler('status_id')"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4" class="text-center pa-0 my-0">
        <global-toggle-filter
          :queries="toggleQueryies"
          ref="toggle_filter_ref"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn large @click="ClearAllFilters" class="error">{{
          $t("button.reset")
        }}</v-btn>
      </v-col>
    </v-row>

    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="program-orders"
      class="table-row"
      dialogWidth="500"
      @get_items="handleGetStatus"
    >
      <template slot-scope="{ item }">
        <td class="text-sm-center">
          <v-avatar size="40">
            <v-img
              @click="
                $refs.table_ref.handleImagePreview(item.program.main_image)
              "
              class="hover-pointer"
              aspect-ratio="1"
              :src="
                item.program
                  ? item.program.main_image.path
                  : '@/assets/imgs/user.jpg'
              "
            ></v-img>
          </v-avatar>
        </td>
        <td class="text-sm-center">
          {{ item.order_number }}
        </td>
        <td class="text-sm-center">
          {{ item.program && item.program.name }}
        </td>
        <td class="text-sm-center">
          {{ item.total_price }}
        </td>
        <td class="align-self-center toggle-spacing text-center">
          <v-switch
            v-model="item.closed"
            @change="handleUpdateprogramState(item)"
          ></v-switch>
        </td>
        <td class="text-sm-center">
          <v-select
            style="width: 220px !important; margin: auto"
            v-model="item.status.id"
            :items="item.statusList"
            item-text="text"
            item-value="id"
            item-disabled="done"
            :loading="statusLoading"
            @change="updateStauts(item)"
          ></v-select>
        </td>
        <td class="text-sm-center">
          <v-icon @click="handleShow(item)" :title="$t('icon.delete')" small
            >mdi-eye</v-icon
          >
        </td>
      </template>
      <template #wrraping_dialog>
        <OrderDetails :order="order" />
      </template>
    </wrapping-table>
  </main>
</template>
<script>
import { IndexData, UpdateData, ShowData } from "@/helpers/apiMethods";
export default {
  name: "Orders",
  components: {
    OrderDetails: () => import("./orderDetails"),
  },
  data() {
    return {
      headers: [
        "photo",
        "order_number",
        "program_name",
        "total_price",
        "closed",
        "status",
        "actions",
      ],
      status: [],
      order: {},
      locale: this.locale,
      statusLoading: true,
      queries: {
        query: {
          order_number: "",
          number_of_month: "",
          receiver_name: "",
        },
      },
      toggleQueryies: {
        query: {
          seen: "",
          closed: "",
        },
      },
      items: [],
      status_id: "",
    };
  },

  methods: {
    handleFitler(name) {
      const queries = {};
      queries[name] = this[name];
      if (queries[name] === "") {
        delete queries[name];
        queries[name] = "";
      }
      if (queries[name] !== "") {
        this.$router.push({ query: { ...this.$route.query, ...queries } });
      }
    },
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      this.$refs.toggle_filter_ref.ClearFilter();
      this.topic = "";
      this.$router.push({ query: {} });
    },
    handleShow({ order_number }) {
      this.$refs.table_ref.toggleDialog();
      ShowData({ reqName: "program-orders", param: order_number }).then(
        (res) => {
          const { program_order } = res.data;
          this.order = program_order;
        }
      );
    },
    updateStauts(item) {
      const reqData = {
        locale: this.locale,
        _method: "put",
        status_id: item.status.id,
      };
      UpdateData({
        reqName: "program-orders",
        data: reqData,
        param: item.order_number,
      }).then(() => {
        item.statusList.find((el) => {
          if (el.id < item.status.id) {
            el.done = true;
          }
        });
      });
    },
    handleUpdateprogramState(item) {
      const reqData = {
        locale: this.locale,
        _method: "put",
        closed: "closed",
      };
      this.popUp().then((value) => {
        if (!value.dismiss) {
          UpdateData({
            reqName: "program-orders",
            data: reqData,
            param: item.order_number,
          });
        } else {
          item.closed = !item.closed;
        }
      });
    },
    handleGetStatus() {
      IndexData({ reqName: "program-statuses", query: { pagination: "all" } })
        .then((res) => {
          const { data } = res.data;
          this.items = data;
          this.$refs.table_ref.items = this.$refs.table_ref.items.map(
            (item) => {
              return {
                ...item,
                statusList: data.map((el) => {
                  return {
                    ...el,
                    done: false,
                  };
                }),
              };
            }
          );

          this.statusLoading = false;
          return this.$refs.table_ref.items;
        })
        .then((items) => {
          items.forEach((item) => {
            item.statusList.forEach((el) => {
              if (el.id < item.status.id) {
                el.done = true;
              }
            });
          });
        });
    },
  },
  watch: {
    $route: {
      handler({ query }) {
        this.status_id = Number(query.status_id);
      },
      immediate: true,
    },
  },
};
</script>
